import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// #region Custom Classes

export interface MessageBoxDialogOptions extends MatDialogConfig {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
}

// #endregion

@Component({
    selector: 'dialog-messagebox-component',
    styleUrls: ['messagebox.dialogcomponent.scss'],
    templateUrl: 'messagebox.dialogcomponent.html',
})
export class MessageBoxDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;

    constructor(
        private dialogRef: MatDialogRef<MessageBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: MessageBoxDialogOptions
    ) {
        this.title = data?.TitleText || 'Information';
        this.message = data?.MessageText || '';
        this.oktext = data?.OKText || 'OK';
    }

    ngOnInit() {}

    OKHandler() {
        this.dialogRef.close(true);
    }
}
